/**
 * NOTIF1 N31: Notification API while a NeoProf tab is open. No service worker, no Web Push.
 * Opt-in is per browser (localStorage); the permission is asked from a settings toggle only.
 */
export const BROWSER_PERMISSION = Object.freeze({
  UNSUPPORTED: 'unsupported', DEFAULT: 'default', GRANTED: 'granted', DENIED: 'denied',
});

const ON = '1';

export const isSupported = () => typeof window !== 'undefined' && 'Notification' in window;

export const permission = () => (isSupported() ? window.Notification.permission : BROWSER_PERMISSION.UNSUPPORTED);

export function isOptedIn(storageKey) {
  try {
    return localStorage.getItem(storageKey) === ON;
  } catch {
    return false;
  }
}

export function setOptedIn(storageKey, value) {
  try {
    if (value) localStorage.setItem(storageKey, ON);
    else localStorage.removeItem(storageKey);
  } catch { /* private mode: stays off */ }
}

/** Asks once (user gesture); returns the resulting permission. */
export async function requestPermission() {
  if (!isSupported()) return BROWSER_PERMISSION.UNSUPPORTED;
  return window.Notification.requestPermission();
}

/** Pop-ups are allowed only when granted AND the user opted in on this browser. */
export const canNotify = (storageKey) => permission() === BROWSER_PERMISSION.GRANTED && isOptedIn(storageKey);
